import { render, staticRenderFns } from "./PhotowallAdd.vue?vue&type=template&id=db033064&"
import script from "./PhotowallAdd.vue?vue&type=script&lang=js&"
export * from "./PhotowallAdd.vue?vue&type=script&lang=js&"
import style0 from "./PhotowallAdd.vue?vue&type=style&index=0&id=db033064&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports